<mat-toolbar>
  <button mat-raised-button matTooltip="Volver" (click)="back()" color='primary' style="margin-right: 15px;"><mat-icon>arrow_back</mat-icon> Volver</button>
  <span class="spacer"></span>
  {{matricula}}
</mat-toolbar>

<mat-tab-group animationDuration="0ms">
  <mat-tab>
    <ng-template mat-tab-label><mat-icon class="tab-icon" color="primary">info</mat-icon>Información</ng-template>
    <mat-toolbar>
      Información
      <span class="spacer"></span>
      <button mat-icon-button matTooltip="Recargar datos" (click)="ngOnInit()"><mat-icon color="primary">refresh</mat-icon></button>
    </mat-toolbar>
    <mat-card class="cardInfo">
      @if (showProgressBar) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
      <form [formGroup]="form">
        <mat-form-field class='formField'>
          <mat-label>Matricula</mat-label>
          <input matInput placeholder="Matricula" formControlName="matricula" [(value)]="matricula">
        </mat-form-field>
        <mat-form-field class='formField'>
          <mat-label>Matricula Antigua</mat-label>
          <input matInput placeholder="Matricula Antigua" formControlName="matricula_old" [(value)]="matricula_old">
        </mat-form-field>
        <mat-form-field class='formField'>
          <mat-label>Medidas</mat-label>
          <input matInput placeholder="Medidas" formControlName="medidas" [(value)]="medidas">
        </mat-form-field>
        <mat-form-field class='formField'>
          <mat-label>Tipo</mat-label>
          <mat-select formControlName="tipo" required [(value)]="tipo">
            <input placeholder="Buscar..." (keyup)="filterSelect_Tipos($event.target.value)" class="inputSelectSearch">
            @for (tipo of tiposSearch; track tipo) {
              <mat-option [value]=tipo.id>{{tipo.nombre}}</mat-option>
            }
          </mat-select>
          <mat-error>Debes seleccionar un tipo.</mat-error>
        </mat-form-field>
        <mat-form-field class='formField'>
          <mat-label>Estado</mat-label>
          <mat-select formControlName="estado" required [(value)]="estado">
            <mat-option value="stock">En Stock</mat-option>
            <mat-option value="cliente">En Cliente</mat-option>
            <mat-option value="maintenance">Mantenimiento</mat-option>
            <mat-option value="baja">Baja</mat-option>
          </mat-select>
          <mat-error>Debes seleccionar un estado.</mat-error>
        </mat-form-field>
        <mat-form-field class='formField'>
          <mat-label>Observaciones</mat-label>
          <input matInput placeholder="Observaciones" formControlName="observaciones" [(value)]="observaciones">
        </mat-form-field>
      </form>
      <button mat-raised-button (click)="save()" color="primary" style="width: 100%;"><mat-icon>save</mat-icon> Guardar</button>
    </mat-card>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label><mat-icon class="tab-icon" color="primary">sync_alt</mat-icon>Movimientos</ng-template>
    <app-view-movimientos [contenedorID]="contenedor"></app-view-movimientos>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label><mat-icon class="tab-icon" color="primary">handyman</mat-icon>Mantenimientos</ng-template>
    <app-view-mantenimintos [contenedorID]="contenedor"></app-view-mantenimintos>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label><mat-icon class="tab-icon" color="primary">photo_library</mat-icon>Galería</ng-template>
    <app-gallery [id]="contenedor" [tipo]="'contenedor'"></app-gallery>
  </mat-tab>
</mat-tab-group>
